var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"projects-timeline"},[_c('div',{staticClass:"content"},[_vm._m(0),_vm._v(" "),_c('canvas',{ref:"canvas",staticClass:"chart",attrs:{"width":"100%"}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mb-2"},[_c('h5',[_vm._v("Completed Projects")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Last 12 Months")])])
}]

export { render, staticRenderFns }